import React from 'react'
import { Link } from 'react-router'
import chunk from 'lodash/chunk'
import Row from 'muicss/lib/react/row'
import Col from 'muicss/lib/react/col'
import util from '../util.js'

const CategoryList = ({ categories }) => (
  <div>
    {chunk(categories, 6).map((row, i) =>
      <Row key={i} className="category-list">
        {row.map(c =>
          <Col key={c.slug} className="category-list__item" md="2" xs="6">
            <Link to={'/categories/'+c.slug}>
              <div className="category-list__image-container">
                <img src={c.image} alt={c.slug} />
              </div>
              <h4 className="category-list__title">{c.title}</h4>
            </Link>
          </Col>
        )}
      </Row>
    )}
    <Col key={'wedding-others'} className="category-list__item" md="2" xs="6">
      <Link to={'/features/' + 'wedding-others'}>
        <div className="category-list__image-container">
          <img src={util.makeS3URL('/data/img-ext/pkg-006001.jpg')} alt={'wedding-others'} />
        </div>
        <h4 className="category-list__title">{'その他ウェディング グッズ'}</h4>
      </Link>
    </Col>
  </div>
)

export default CategoryList



// WEBPACK FOOTER //
// ./src/components/CategoryList.js